import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Search } from "@mui/icons-material";
import { Grid, InputAdornment, Pagination, Stack, TextField } from "@mui/material";

import DisputeTableCellRemake from "./DisputeTableCellRemake";

import { useDispatch } from "react-redux";
import {
  getAllDisputes,
  getDateFilterDisputes,
} from "../../../../../../api/order";
import TabLabel from "../../../../components/TabLabel";
import adminIndex from "../../../../components/adminIndex.module.css";
import NotFound from "../../../../../../components/NotFound";
import DatePicker from "../../../../../../components/orders/DatePicker";
import AdminTablesPagination from "../../../../components/AdminTablesPagination";
import { debounce } from "../../../../../../utils/debounce";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function DisputeTabs({
  disputeInfo,
  pendingDisputeInfo,
  deliveredDisputeInfo,
  loading,
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (startDate && endDate !== null) {
      dispatch(
        getDateFilterDisputes({ start_date: startDate, end_date: endDate })
      );
    }
  }, [startDate, endDate, dispatch]);

  const handleSearch = (value) => {
    dispatch(getAllDisputes({ text: value }));
  };

  const optimizedFunction = React.useCallback(debounce(handleSearch), []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // dispatch(getAllProducts({ page: newPage - 1, size: 50 }));
    dispatch(
      getAllDisputes({
        page: newPage - 1,
        size: 50,

        status:
          value === 1
            ? "Waiting"
            : value === 2
            ? "reply"
            : value === 3
            ? "complete"
            : value === 4
            ? "archived"
            : "",
      })
    );
  };

  return (
    <Box className={adminIndex.card}>
      <Box>
        <Tabs
          value={value}
          sx={{ position: "relative", zIndex: 1 }}
          onChange={handleChange}
          aria-label="basic tabs example"
          inkBarStyle={{ backgroundColor: "#000" }}
        >
          <Tab
            onClick={() => dispatch(getAllDisputes({ page: 0, size: 50 }))}
            label={<TabLabel label="All" count={disputeInfo?.totalDisputes} />}
            {...a11yProps(0)}
          />
          <Tab
            onClick={() => dispatch(getAllDisputes({ status: "pending" }))}
            label={<TabLabel label="Waiting" count={disputeInfo?.totalPendingDisputes} />}
            {...a11yProps(1)}
          />
          <Tab
            onClick={() => dispatch(getAllDisputes({ status: "reply" }))}
            label={<TabLabel label="Reply" count={disputeInfo?.totalReplyDisputes} />}
            {...a11yProps(2)}
          />
          <Tab
            onClick={() => dispatch(getAllDisputes({ status: "complete" }))}
            label={<TabLabel label="Complete" count={disputeInfo?.totalCompletedDisputes} />}
            {...a11yProps(3)}
          />
          <Tab
            onClick={() => dispatch(getAllDisputes({ status: "archived" }))}
            label={<TabLabel label="Archived" count={disputeInfo?.totalArchivedDisputes} />}
            {...a11yProps(4)}
          />
          <Tab
            onClick={() => dispatch(getAllDisputes({ status: "returned" }))}
            label={<TabLabel label="awaiting carrier" count={disputeInfo?.totalReturnedToChina} />}
            {...a11yProps(5)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Grid container sx={{ padding: " 0px 15px", marginTop: "15px" }}>
          <Grid item xs={6.6}>
            <TextField
              size="small"
              sx={{ width: "100%" }}
              placeholder="Search Disputes"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => optimizedFunction(e.target.value)}
            />
          </Grid>
          <Grid
            sx={{
              ".MuiInputLabel-root.Mui-focused": {
                top: 0,
              },
              ".MuiInputLabel-root": {
                top: "-7px",
              },
              ".MuiOutlinedInput-input": {
                height: "9px!important",
              },
            }}
            item
            xs={5.4}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <h6
                style={{
                  marginLeft: "40px",
                  width: "150px",
                  textAlign: "right",
                }}
              >
                Search By
              </h6>
              <div style={{ margin: "0px 20px" }}>
                <DatePicker
                  title="Start Date"
                  value={startDate}
                  sx={{
                    "& .MuiInputBase-input-MuiOutlinedInput-input": {
                      fontSize: "12px",
                    },
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(newValue) => setStartDate(newValue?.$d)}
                />
              </div>
              <DatePicker
                title="End Date"
                value={endDate}
                renderInput={(params) => <TextField {...params} />}
                onChange={(newValue) => setEndDate(newValue?.$d)}
              />
            </div>
          </Grid>
        </Grid>
        {(disputeInfo?.disputes?.length > 0 && !loading) ? (
          <DisputeTableCellRemake disputeInfo={disputeInfo?.disputes} />
        ) : (
          <NotFound
            margin="5%"
            loading={loading}
            content="disputes"
            subContent="haven't opended any dispute"
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {(disputeInfo?.disputes?.length > 0 && !loading) ? (
          <DisputeTableCellRemake disputeInfo={disputeInfo?.disputes?.filter((dispute) => dispute?.conversationStatus === 'Waiting')} />
        ) : (
          <NotFound
            margin="5%"
            loading={loading}
            content="disputes"
            subContent="do not have any dispute in pending"
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {(disputeInfo?.disputes?.length > 0 && !loading) ? (
          <DisputeTableCellRemake disputeInfo={disputeInfo?.disputes} />
        ) : (
          <NotFound
            margin="5%"
            loading={loading}
            content="disputes"
            subContent="do not have any delivered dispute"
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={3}>
        {(disputeInfo?.disputes?.length > 0 && !loading) ? (
          <DisputeTableCellRemake disputeInfo={disputeInfo?.disputes} />
        ) : (
          <NotFound
            margin="5%"
            loading={loading}
            content="disputes"
            subContent="do not have any delivered dispute"
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={4}>
        {(disputeInfo?.disputes?.length > 0 && !loading) ? (
          <DisputeTableCellRemake disputeInfo={disputeInfo?.disputes} />
        ) : (
          <NotFound
            margin="5%"
            loading={loading}
            content="disputes"
            subContent="do not have any delivered dispute"
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={5}>
        {(disputeInfo?.disputes?.length > 0 && !loading) ? (
          <DisputeTableCellRemake disputeInfo={disputeInfo?.disputes} />
        ) : (
          <NotFound
            margin="5%"
            loading={loading}
            content="disputes"
            subContent="do not have any returned dispute"
          />
        )}
      </TabPanel>

      <div className={adminIndex.footer}>
          <p style={{ margin: 0 }}>
            Total Disputes:{" "}
            <strong>{(value === 0
              ? disputeInfo?.totalDisputes
              : value === 1
              ? disputeInfo?.totalPendingDisputes
              : value === 2
              ? disputeInfo?.totalReplyDisputes
              : value === 3
              ? disputeInfo?.totalCompletedDisputes
              : value === 4 ? disputeInfo?.totalArchivedDisputes: disputeInfo?.totalReturnedToChina) ?? 0}</strong>
          </p>

          <Pagination
            onChange={handleChangePage}
            sx={{
              ".MuiPagination-root": {
                ".Mui-selected": {
                  backgroundColor: "#8D40FF",
                  color: "#fff",
                },
              },
            }}
            defaultPage={page || 1}
            // page={page}
            count={Math.ceil(
              value === 0
                ? disputeInfo?.totalDisputes / 50
                : value === 1
                ? disputeInfo?.totalPendingDisputes / 50
                : value === 2
                ? disputeInfo?.totalReplyDisputes / 50
                : value === 3
                ? disputeInfo?.totalCompletedDisputes / 50
                : disputeInfo?.totalArchivedDisputes / 50
            )}
            shape="rounded"
          />
        </div>
    </Box>
  );
}
